import {IRouteStore} from '../../router/routing.infra';
import {getRootStore} from '../../app.bootstrap';
import {ISessionEndedController, SessionEndedController} from '../../components/session-ended/controller';

export interface ISessionEndedStore extends IRouteStore {
    sessionEndedController: ISessionEndedController;
    dispose(): void;
}

export class SessionEndedStore implements ISessionEndedStore {
    public sessionEndedController: ISessionEndedController;

    constructor() {
        const rootStore = getRootStore();
        const translate = rootStore.localizationService.translate;

        this.sessionEndedController = new SessionEndedController(translate);
    }

    dispose(): void {}
}
